import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from '../../common';
import { CodeCodetablePickerProps } from './types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ValidationProps, ValidationLevel } from 'ui';
import { isDisabled } from 'app/infrastructure/data/date';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const CodeNode = (props: CodeCodetablePickerProps) => {

  const { breadcrumbs, metadata, codeItem, onChange, options, loadOptions, translation, validation,
    readOnly } = props;

  if (!metadata || !metadata.codetableNode || !isDefinedIncludingZero(metadata.codetableNode.id)) {
    return null;
  }

  const codetableNodeId = !!metadata && !!metadata.codetableNode && isDefinedIncludingZero(metadata.codetableNode.id)
    ? metadata.codetableNode.id
    : undefined;

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id, codetableNodeId, loadOptionsParams);
  };

  const codeOptions = (!!options.node && options.node.codes || []) as CodeComplexValue<number>[];

  const disabledNodeValidation: ValidationProps = !!codeItem && codeItem.node && isDisabled(codeItem.node.disabled) ?
    {
      level: ValidationLevel.warning, messages: [{
        level: ValidationLevel.warning,
        message: translation.selected_value_disabled
      }]
    } : undefined;

  const nodeValidation = !!validation && !!validation.node ? validation.node : undefined;
  const finalValidation = { ...nodeValidation, ...disabledNodeValidation };

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableNodeId, breadcrumbs);

  return <CodeSinglePicker
    id="node"
    label={translation ? translation.list_code : undefined}
    valueItem={codeItem && codeItem.node}
    searchRequired={codetableNodeId && metadata.codetableNode.searchRequired}
    required={!readOnly}
    readOnly={readOnly}
    options={codeOptions}
    fetchingOptions={options.node && options.node.fetching}
    extraFooterButton={extraFooterButton}

    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    validation={finalValidation}
  />;
};
